import axios from "../../privateApi";

export const deleteTactic = async (tacticId: string) =>
  await axios.delete(`/tactics/${tacticId}`);
